export default __webpack_public_path__ + "static/media/sSPELL.aee7731c.png";